import { DrawerCanvas } from '../DrawerCanvas';
import { bBrowser } from '../utils';
/**
 *
 * @category DrawerCanvas
 * @class BrowserDrawerCanvas
 * @extends {DrawerCanvas}
 */
class BrowserDrawerCanvas extends DrawerCanvas {
    constructor(scene, canvasOrContainer, drawerOptions, duration = 60000, framerate = 60, tickMode = drawerOptions?.clear === false ? 'linear' : 'async') {
        super(scene, canvasOrContainer, drawerOptions, duration, framerate, tickMode);
        this.dpi = 1;
        this.loop = true;
        this.dpi = drawerOptions?.dpi || 1;
        this.loop = drawerOptions?.loop === false ? false : true;
        this.draw_id = null;
        this.redraw_id = null;
        this.animation_id = null;
        this.draw = this.draw.bind(this);
        this.animate = this.animate.bind(this);
        this.startAnimation = this.startAnimation.bind(this);
        this.resize(this.drawerOptions.width || scene?.width || 400, this.drawerOptions.height || scene?.height || 400);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    setCanvas(canvasOrContainer) {
        super.setCanvas(canvasOrContainer);
    }
    /**
     * Return option value or default
     *
     * @param {K keyof IBrowserDrawerCanvasOptions} name
     * @param {IBrowserDrawerCanvasOptions[K]} value
     */
    setOption(name, value) {
        if (name === 'loop') {
            this.loop = value === false ? false : true;
        }
        else if (name === 'dpi') {
            this.dpi = typeof value === 'number' ? value : 1;
        }
        else {
            super.setOption(name, value);
        }
    }
    resize(width, height, sceneFit, dpi = this.dpi) {
        this.drawerOptions.width = width * dpi;
        this.drawerOptions.height = height * dpi;
        if (this.canvas) {
            this.canvas.width = width * dpi;
            this.canvas.height = height * dpi;
            if (bBrowser && this.canvas instanceof HTMLCanvasElement) {
                this.canvas.style.width = width + 'px';
                this.canvas.style.height = height + 'px';
            }
        }
        if (typeof sceneFit !== 'undefined') {
            this.drawerOptions.sceneFit = sceneFit;
        }
        this.dispatch('drawer-canvas:resize');
    }
    /**
     * Internal tick animation
     */
    animate(timestamp) {
        if (this.timeline.bSequenceStarted()) {
            this.animation_id = requestAnimationFrame(this.animate);
            if (this.timeline.tick(timestamp)) {
                if (this.loop || (this.loop === false && this.timeline.getCurrentLoop() === 0))
                    this.draw();
                else {
                    cancelAnimationFrame(this.animation_id);
                    this.timeline.setTime(this.timeline.getSequence().duration - 0.00001);
                    this.draw();
                }
            }
        }
    }
    handleVisibilityChange() {
        if (document.hidden) {
            this.pauseAnimation();
        }
        else {
            this.playAnimation();
        }
    }
    /**
     * Start animation drawing
     */
    startAnimation() {
        this.stopAnimation();
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
        this.timeline.start();
        this.animation_id = requestAnimationFrame(this.animate);
    }
    /**
     * Stop animation drawing
     */
    stopAnimation() {
        this.timeline.stop();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.animation_id)
            cancelAnimationFrame(this.animation_id);
    }
    /**
     * Pause animation drawing
     */
    pauseAnimation() {
        this.timeline.pause();
        if (this.animation_id)
            cancelAnimationFrame(this.animation_id);
    }
    /**
     * Play animation drawing
     */
    playAnimation() {
        this.timeline.start();
        requestAnimationFrame(this.animate);
    }
    redraw() {
        if (!this.timeline.bSequenceStarted()) {
            this.draw_id && cancelAnimationFrame(this.draw_id);
            if (typeof this.drawerOptions.ghosts === undefined || this.drawerOptions.ghosts === 0)
                this.timeline.stop();
            this.draw_id = requestAnimationFrame(this.draw);
        }
        else if (typeof this.drawerOptions.ghosts === undefined || this.drawerOptions.ghosts === 0) {
            this.stopAnimation();
            this.redraw_id && cancelAnimationFrame(this.redraw_id);
            this.redraw_id = requestAnimationFrame(this.startAnimation);
        }
    }
}
export { BrowserDrawerCanvas };
//# sourceMappingURL=BrowserDrawerCanvas.js.map